"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.i18n = exports.default = void 0;
var _vue = _interopRequireDefault(require("vue"));
var _vueI18n = _interopRequireDefault(require("vue-i18n"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
_vue.default.use(_vueI18n.default); // 全局挂载

var i18n = new _vueI18n.default({
  locale: localStorage.getItem("locale") || "zh-cn",
  // 从localStorage中获取 默认英文
  messages: {
    'zh-cn': require("./zh"),
    // 中文语言包
    'en-us': require("./en"),
    // 英文语言包
    'zh-bn': require("./zh-bn") // 繁体中文
  }
});
exports.i18n = i18n;
var _default = i18n;
exports.default = _default;